(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["gg-purchase-help"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('gg-purchase-help')) {
    customElements.define('gg-purchase-help', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        this.querySelector('[data-size-help]')?.addEventListener('click', event => {
          const details = this.closest('.shopify-section')?.querySelector('[data-gg-size-fit]');
          if (!details) return;
          event.preventDefault();
          details.open = true;
          details.querySelector('summary')?.focus({ preventScroll: true });
          details.scrollIntoView({ block: 'start', behavior: 'instant' });
        }, { signal: this.controller.signal });
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
